import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation files
import en from "./translations/en.json";
import sr from "./translations/sr.json";

const resources = {
  EN: en,
  SR: sr,
};

export const availableLanguages = Object.keys(resources);

// One-time cleanup: ranija buggy migracija je postavila 'EN' u localStorage
// za korisnike koji su zapravo imali 'en-US' (iz OS-a), iako oni nisu
// eksplicitno menjali jezik u app-u. Ako ne postoji marker da je korisnik
// SAM kliknuo Switch, resetuj na podrazumevani SR.
const userChoseLang = localStorage.getItem("i18n_user_chose") === "true";
if (!userChoseLang) {
  localStorage.removeItem("i18nextLng");
}

i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  defaultNS: "common",
  fallbackLng: "SR",
});
